<template>
  <Link
    :href="Links.homepage.orderTracking.url"
    :tracking="Links.homepage.orderTracking.tracking"
    class="rail-btn-hover rail-btn-nowrap undecorated-link"
  >
    <i class="icon-28x28 track-shipment margin-right-xxs"></i>
    <span class="grid-x heavy-sm">Order tracking</span>
  </Link>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import Link from '~/components/common/Link';
import Links from '#shared/constants/Links';
</script>
